import { PatientState, SubscriptionState } from "src/base/Enums";
import { action } from "typesafe-actions";
import { UnsharedFilesActionType } from "./types";


export function unsharedFilesCountUpdated(count: number) {
  return action(UnsharedFilesActionType.UNSHARED_FILES_COUNT_UPDATED, { count })
}